<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YtDAyp/tc-custom/9781646562435.jpg?1723408608289" alt="This image is the cover for the book The Portal's Gift"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Portal's Gift
      </h1>
      <p class="bookDescription body article font2">
        <p>The most famous astronaut on earth discovers hyperspace has interesting consequences when he is marooned with his alien shipmate.<br/><br/>When Earth joins forces with the friendly Teneran aliens to gain access to their hyperspace drive, Josh is the first human to copilot with a Teneran commander. On the <i>Marco Polo</i>, a Terran ship equipped with the alien drive, he and the enigmatic Teneran Paris explore distant worlds no astronaut from earth could have visited without help from the aliens.<br/><br/>Not until a blinding sandstorm maroons Josh and Paris on a desolate planet does Josh realize the implications of the Teneran drive. He finds himself unaccountably attracted to Paris. Will his travels through the portals of space change his life forever?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol Holland March
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3490df38